import { type GenericObject } from '@bizzdesign/modeler/models';
import { getElementType } from '@bizzdesign/modeler/utils-canvazz';
import { formatName } from '../common/formatting.utils';

export { getElementType } from '@bizzdesign/modeler/utils-canvazz';

export const isDeletedFromRepo = (element: GenericObject): boolean => {
  return !!element['metadata']?.['isDeletedFromRepo'];
};

export function getElementDefaultName(element: GenericObject): string {
  const type = getElementType(element);
  const { typeName, shapeType, promotion } = element;

  switch (type) {
    case 'shape':
      return formatName(shapeType);

    case 'text':
      return formatName(typeName);

    case 'archiMate':
    case 'relation':
    case 'fromRepo':
      return formatName(promotion?.typeName ?? typeName);

    case 'formalObject':
      return formatName(promotion?.typeName ?? typeName);

    case 'line':
      return formatName(typeName);

    default:
      return '';
  }
}

export function isElementRelation(diagramElementData?: GenericObject): boolean {
  if (!diagramElementData) return false;

  return !!(diagramElementData['targetId'] && diagramElementData['sourceId']);
}

export function isEmptyTextBlock(diagramElementData?: GenericObject): boolean {
  if (!diagramElementData) return false;

  return (
    diagramElementData['typeName'] === 'Text' &&
    !diagramElementData['name']?.['en']
  );
}
